/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["nyn",[["AM","PM"],u,u],u,[["S","K","R","S","N","T","M"],["SAN","ORK","OKB","OKS","OKN","OKT","OMK"],["Sande","Orwokubanza","Orwakabiri","Orwakashatu","Orwakana","Orwakataano","Orwamukaaga"],["SAN","ORK","OKB","OKS","OKN","OKT","OMK"]],u,[["J","F","M","A","M","J","J","A","S","O","N","D"],["KBZ","KBR","KST","KKN","KTN","KMK","KMS","KMN","KMW","KKM","KNK","KNB"],["Okwokubanza","Okwakabiri","Okwakashatu","Okwakana","Okwakataana","Okwamukaaga","Okwamushanju","Okwamunaana","Okwamwenda","Okwaikumi","Okwaikumi na kumwe","Okwaikumi na ibiri"]],u,[["BC","AD"],u,["Kurisito Atakaijire","Kurisito Yaijire"]],1,[0,0],["dd/MM/y","d MMM y","d MMMM y","EEEE, d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"UGX","USh","Eshiringi ya Uganda",{"JPY":["JP¥","¥"],"UGX":["USh"],"USD":["US$","$"]},"ltr", plural];
